import axios from "axios";
import { Constants } from "../utils/constants";
import { guestApi } from "./GuestApiAccess";

export const generateToken = async () => {
  const token = await axios
    .post(
      Constants.URL.base + Constants.URL.auth,
      {
        grant_type: "client_credentials",
        client_secret: Constants.client.secret,
        client_id: Constants.client.id,
      },
      {
        headers: {
          "content-type": "application/x-www-form-urlencoded",
        },
      },
    )
    .then((data) => data?.data)
    .catch((error) => {
      console.log(error);
    });
  return token;
};

export const verifyUser = async (email, otp) => {
  const url = Constants.URL.verify + "?email=" + email + "&otp=" + otp;

  try {
    const response = await guestApi.get(url);

    return response.data;
  } catch (error) {
    console.error("Axios error:", error);
    return null;
  }
};
